export default __webpack_public_path__ + "static/media/icon-img-3.e68526cc.webp";